'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _StorageFactory = require('./StorageFactory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides functionality to manipulate and check a user session.
 */
var SessionUtils = function () {
    function SessionUtils() {
        (0, _classCallCheck3.default)(this, SessionUtils);

        this.storage = (0, _StorageFactory.getWorkingStorage)();
    }

    (0, _createClass3.default)(SessionUtils, [{
        key: 'getRefreshToken',
        value: function getRefreshToken() {
            return this.storage.getRefreshToken();
        }
    }, {
        key: 'saveRefreshToken',
        value: function saveRefreshToken(token) {
            this.storage.saveRefreshToken(token);
        }
    }, {
        key: 'getSessionToken',
        value: function getSessionToken() {
            return this.storage.getSessionToken();
        }
    }, {
        key: 'saveSessionToken',
        value: function saveSessionToken(token) {
            this.storage.saveSessionToken(token);
        }
    }, {
        key: 'isLoggedIn',
        value: function isLoggedIn() {
            return this.storage.isLoggedIn();
        }
    }, {
        key: 'deleteSession',
        value: function deleteSession() {
            this.storage.deleteSessionToken();
            this.storage.deleteRefreshToken();
        }
    }]);
    return SessionUtils;
}();

exports.default = SessionUtils;
